import css from 'styled-jsx/css';

export default css.global`.nav-menu {
  background-color: #fff;
}

.nav-menu p {
  margin: 0;
}

.menu-title {
  background-color: #E6F4EB;
  padding: 3rem 1rem;
}

.menu-title p {
  color: #025E35;
  font-weight: bold;
  font-size: 22px;
}

.menu-list {
  padding: 1.5rem 1.5rem 4rem;
}

.nav-menu-item__title {
  color: #76808b;
  text-transform: uppercase;
  font-size: 16px;
  font-weight: bold;
  position: relative;
}

/* .nav-menu-item__title::after {
  content: "";
  display: block;
  width: 40px;
  border-top: 4px solid #b1272c;
  position: absolute;
  bottom: -5px;
  left: 0;
} */

.nav-menu-item__link-list {
  margin-top: 1rem;
  padding-top: 1rem;
  display: grid;
  gap: 1rem;
}

.nav-menu-item__link {
  display: flex;
  align-items: flex-start;
  padding: 0.5rem 0;
}

.nav-menu-item__link:hover {
  background-color: #cce4ff6b;
}

.nav-menu-item__link > img {
  width: 40px;
  margin-right: 1rem;
  padding-left: 1rem;
}

.nav-menu-item__link-name {
  display: flex;
  flex-direction: column;
  color: #212429;
  padding-right: 0.5rem;
}

.nav-menu-item__link-name .__title {
  font-size: 14px;
}

.nav-menu-item__link-name .__sub-title {
  font-size: 13px;
}

.nav-menu-item__link-name .__title.bold {
  font-weight: bold;
}

.menu-list {
  display: flex;
  flex-direction: column;
}

.nav-menu-item {
  /* padding: 2rem 0; */
}

.nav-menu-item:nth-child(even) {
  border-top: 1px solid #f2f2f2;
  border-bottom: 1px solid #f2f2f2;
}

@media (min-width: 1023px) {
  .nav-menu {
    display: grid;
    grid-template-columns: 2fr 7fr;
  }

  .menu-title p {
    font-size: 2.5rem;
  }
  .menu-title {
    padding: 2rem;
  }

  .menu-list {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 2rem;
    padding: 1.5rem;
  }

  .nav-menu-item:nth-child(even) {
    border-top: none;
    border-bottom: none;
    border-right: 1px solid #f2f2f2;
    border-left: 1px solid #f2f2f2;
    padding-right: 2rem;
    padding-left: 2rem;
  }
}
`